import React, { useState, useEffect } from "react";
import { TextInput } from "..";
import ArticleSearchResults from "./ArticleSearchResults";
import { Modal } from "..";
import { updateModal } from "@/store/app/app.slice";

interface ArticleSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialQuery?: string;
  hostid?: string;
  onArticlePreview?: (article: any) => void;
  selectedArticles?: any[];
  onSelectedArticlesChange?: (articles: any[]) => void;
  mediaId?: string;
  onAddDenmarkEmbedChip?: (article: any, type: "lead" | "embed") => void;
  formikDenmarkValues?: any[];
  denmarkHosts?: any[];
}

const ArticleSearchModal: React.FC<ArticleSearchModalProps> = ({
  isOpen,
  onClose,
  initialQuery = "",
  hostid,
  onArticlePreview,
  selectedArticles = [],
  onSelectedArticlesChange,
  mediaId,
  onAddDenmarkEmbedChip,
  formikDenmarkValues = [],
  denmarkHosts = [],
}) => {
  // const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [suggestedArticles, setSuggestedArticles] = useState<any[]>([]);
  // const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  // Sync search query when modal opens with new initialQuery
  useEffect(() => {
    if (isOpen && initialQuery) {
      setSearchQuery(initialQuery);
    }
  }, [isOpen, initialQuery]);

  const handleClose = () => {
    setSearchQuery("");
    setSuggestedArticles([]);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Search Articles"
      width="100%"
      closeOnOutsideClick={true}
      height="100vh"
      updateModal={updateModal}
    >
      <div className="d-flex flex-column gap-3">
        <div
          className="d-flex align-items-center bg-light px-3 py-2 position-sticky z-2"
          style={{
            marginTop: "-14px",
            top: "-14px",
            marginLeft: "-14px",
            width: "calc(100% + 28px)",
          }}
        >
          <div className="border-end flex-grow-1 pe-3 me-3">
            <TextInput
              label=""
              name="search"
              placeholder="Search for Article titles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-100"
            />
          </div>
          {/* <Button type="outline-primary" onClick={handleSuggestArticles} isDisabled={loadingSuggestions}>
            {loadingSuggestions ? 'Loading...' : 'Get Recommendations'}
          </Button> */}
        </div>
        <div className="d-flex flex-column gap-2 z-1 position-relative">
          <ArticleSearchResults
            searchQuery={searchQuery}
            showInlineResults={false}
            maxInlineResults={50}
            hostid={hostid}
            onArticlePreview={onArticlePreview}
            showActionButtons={true}
            selectedArticles={selectedArticles}
            onSelectedArticlesChange={onSelectedArticlesChange}
            isInModal={true}
            mediaId={mediaId}
            onAddDenmarkEmbedChip={onAddDenmarkEmbedChip}
            formikDenmarkValues={formikDenmarkValues}
            denmarkHosts={denmarkHosts}
          />
          {suggestedArticles.length > 0 && (
            <div className="mt-4">
              <h6 className="mb-3 text-primary">Suggested Articles</h6>
              <ArticleSearchResults
                searchQuery=""
                showInlineResults={false}
                maxInlineResults={50}
                hostid={hostid}
                onArticlePreview={onArticlePreview}
                showActionButtons={true}
                selectedArticles={selectedArticles}
                onSelectedArticlesChange={onSelectedArticlesChange}
                suggestedArticles={suggestedArticles}
                mediaId={mediaId}
                onAddDenmarkEmbedChip={onAddDenmarkEmbedChip}
                formikDenmarkValues={formikDenmarkValues}
                denmarkHosts={denmarkHosts}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ArticleSearchModal;
